// Require core-js to load polyfills.
require('core-js')

// Set up Sentry as the first thing, so we can be rest assured that we catch all errors.
if (process.env.SENTRY_BROWSER_DSN) {
  const Sentry = require('@sentry/browser')
  const { RewriteFrames } = require('@sentry/integrations')

  Sentry.init({
    environment: process.env.APP_ENV || 'local',
    release: process.env.RELEASE,
    dsn: process.env.SENTRY_BROWSER_DSN,
    integrations: [new RewriteFrames()],
    normalizeDepth: 5,
    beforeBreadcrumb (breadcrumb) {
      // Don't send any debug logs to Sentry since it will result in a payload that's too big
      // and will be rejected (413: Request entity too large)
      if (breadcrumb.category === 'console' && breadcrumb.level === 'debug') {
        return null
      } else {
        return breadcrumb
      }
    }
  })
}
